window.mobile_nav = function () {
  return {
    show_nav: false,
    show_language: false,

    artworksOpenSecoundary: "",
    artworksOpenThird: "",

    artistsOpenSecoundary: "",
    artistsOpenThird: "",
    setArtworksSecoundary($e) {
      this.artworksOpenSecoundary = $e.currentTarget.dataset.name;
      this.artworksOpenThird = "";
    },
    setArtworksThird($e) {
      this.artworksOpenThird = $e.currentTarget.dataset.name;
    },
    setArtistsSecoundary($e) {
      this.artistsOpenSecoundary = $e.currentTarget.dataset.name;
      this.artistsOpenThird = "";
    },
    setArtistsThird($e) {
      this.artistsOpenThird = $e.currentTarget.dataset.name;
    },
  };
};
